export var SrciButtonColorEnumsObj = {
    BLACK: "black",
};
